var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3440({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 4.5,
    stroke: "#747BA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10C19.6266 10 17.3066 10.7038 15.3332 12.0224C13.3598 13.3409 11.8217 15.2151 10.9135 17.4078C10.0052 19.6005 9.76756 22.0133 10.2306 24.3411C10.6936 26.6689 11.8365 28.807 13.5147 30.4853C15.193 32.1635 17.3311 33.3064 19.6589 33.7694C21.9867 34.2324 24.3995 33.9948 26.5922 33.0865C28.7849 32.1783 30.6591 30.6402 31.9776 28.6668C33.2962 26.6934 34 24.3734 34 22C34 20.4241 33.6896 18.8637 33.0866 17.4078C32.4835 15.9519 31.5996 14.629 30.4853 13.5147C29.371 12.4004 28.0481 11.5165 26.5922 10.9134C25.1363 10.3104 23.5759 10 22 10ZM21.4 13.6C21.756 13.6 22.104 13.7056 22.4 13.9034C22.696 14.1011 22.9267 14.3823 23.063 14.7112C23.1992 15.0401 23.2349 15.402 23.1654 15.7512C23.096 16.1003 22.9245 16.4211 22.6728 16.6728C22.4211 16.9245 22.1003 17.096 21.7512 17.1654C21.402 17.2349 21.0401 17.1992 20.7112 17.063C20.3823 16.9267 20.1011 16.696 19.9034 16.4C19.7056 16.104 19.6 15.756 19.6 15.4C19.6 14.9226 19.7896 14.4648 20.1272 14.1272C20.4648 13.7896 20.9226 13.6 21.4 13.6ZM24.4 29.2H23.2C22.5635 29.2 21.953 28.9471 21.5029 28.4971C21.0529 28.047 20.8 27.4365 20.8 26.8V22C20.4817 22 20.1765 21.8736 19.9515 21.6485C19.7264 21.4235 19.6 21.1183 19.6 20.8C19.6 20.4817 19.7264 20.1765 19.9515 19.9515C20.1765 19.7264 20.4817 19.6 20.8 19.6H22C22.3183 19.6 22.6235 19.7264 22.8485 19.9515C23.0736 20.1765 23.2 20.4817 23.2 20.8V26.8H24.4C24.7183 26.8 25.0235 26.9264 25.2485 27.1515C25.4736 27.3765 25.6 27.6817 25.6 28C25.6 28.3183 25.4736 28.6235 25.2485 28.8485C25.0235 29.0736 24.7183 29.2 24.4 29.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3440);
export default __webpack_public_path__ + "static/media/Group 3440.3381ae8d13e118705e6bc3beb2ec3662.svg";
export { ForwardRef as ReactComponent };